import axios from "axios";
import { API_BASE_URL, resolvePublicFileUrl } from "../constants/api-urls";
import superAdminApi from "./superAdminApi";
import defaultAuthFounderHeroImage from "../assets/images/auth/super-admin-founder-hero.png";

export const AUTH_FOUNDER_HERO_SETTING_KEY = "auth_founder_hero_image_url";

export const DEFAULT_AUTH_FOUNDER_HERO_PATH = "/media/auth/super-admin-founder-hero.png";

const extractData = (res) => res?.data?.data ?? res?.data ?? null;

const normalizeMediaPath = (value) => String(value || "").trim().replace(/\\/g, "/");

export function isDefaultAuthFounderHeroPath(pathOrUrl) {
  const normalized = normalizeMediaPath(pathOrUrl);
  return (
    !normalized ||
    normalized === DEFAULT_AUTH_FOUNDER_HERO_PATH ||
    normalized.endsWith("/public/media/auth/super-admin-founder-hero.png") ||
    normalized.endsWith("/media/auth/super-admin-founder-hero.png")
  );
}

/** Bundled + public default used when DB stores the default media path. */
export function getDefaultAuthFounderHeroUrl() {
  if (defaultAuthFounderHeroImage) {
    return defaultAuthFounderHeroImage;
  }
  const publicPath = `${process.env.PUBLIC_URL || ""}/media/auth/super-admin-founder-hero.png`;
  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${publicPath.startsWith("/") ? publicPath : `/${publicPath}`}`;
  }
  return resolvePublicFileUrl(DEFAULT_AUTH_FOUNDER_HERO_PATH);
}

export function resolveAuthFounderHeroUrl(pathOrUrl) {
  if (isDefaultAuthFounderHeroPath(pathOrUrl)) {
    return getDefaultAuthFounderHeroUrl();
  }
  return resolvePublicFileUrl(pathOrUrl);
}

export async function fetchPublicAuthFounderHeroUrl() {
  try {
    const res = await axios.get(`${API_BASE_URL}/public/platform/bootstrap`, {
      timeout: 15000,
    });
    const settings = extractData(res)?.settings ?? {};
    const configured = settings[AUTH_FOUNDER_HERO_SETTING_KEY];
    if (typeof configured === "string" && configured.trim()) {
      return resolveAuthFounderHeroUrl(configured);
    }
  } catch {
    // Fall back to bundled default image.
  }
  return getDefaultAuthFounderHeroUrl();
}

export async function fetchAuthFounderHeroSetting() {
  const res = await superAdminApi.get("/super-admin/auth-founder-hero");
  return extractData(res)?.setting ?? null;
}

export async function saveAuthFounderHeroImageUrl(imagePath) {
  const normalized = String(imagePath || "").trim() || DEFAULT_AUTH_FOUNDER_HERO_PATH;
  const res = await superAdminApi.put("/super-admin/auth-founder-hero", {
    setting_value: normalized,
  });
  return extractData(res)?.setting ?? null;
}

export async function uploadAuthFounderHeroImage(file) {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("category", "auth");
  formData.append("companyName", "Founder_Hero");
  formData.append("fileType", "auth_founder_hero_image");

  const res = await superAdminApi.post("/upload/single", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  const imagePath = res?.data?.data?.accessPath || res?.data?.data?.filePath || null;
  if (!imagePath) {
    throw new Error("Hero image upload failed.");
  }
  return imagePath;
}
